import { Brand, createBranded } from '@deltasierra/type-utilities';
import { getEntries } from '@deltasierra/utilities-object';
import { IntegrationDescriptionBaseUnion } from './IntegrationDescriptionBase';

export type IntegrationLevel = IntegrationDescriptionBaseUnion['level'];
export type IntegrationLevelIdType = IntegrationDescriptionBaseUnion['id'];

export type IntegrationLevelId = Brand<number, 'IntegrationLevelId'>;
const IntegrationLevelId = createBranded<IntegrationLevelId>();

type IntegrationLevelIdMappingType = {
    [key in IntegrationLevel]: number;
};

const IntegrationLevelIdMapping: IntegrationLevelIdMappingType = {
    agency: 1,
    client: 2,
    location: 3,
};

export function toIntegrationLevelId(integrationLevel: IntegrationLevel): IntegrationLevelId {
    return IntegrationLevelId.from(IntegrationLevelIdMapping[integrationLevel]);
}

export function fromIntegrationLevelId(integrationLevelId: IntegrationLevelId): IntegrationLevel {
    const level = getEntries(IntegrationLevelIdMapping).find(([_key, value]) => value === integrationLevelId)?.[0];
    if (!level) {
        throw new Error('Invalid integration level id');
    }
    return level;
}
